import { useTranslation } from 'react-i18next';
import { useSortByFilter } from 'lib/hooks/useSrpFilters';
import List from 'components/Shared/List';

interface SortByModalDropdownProps {
  onListItemClick?: (value?: string) => void;
  isSeo?: boolean;
}

export default function SortByModal({ onListItemClick }: SortByModalDropdownProps): JSX.Element {
  const { value, setValue } = useSortByFilter();
  const sortByOptions = useSortFilterOptions();

  function onClick(val?: string): void {
    setValue(val);
    onListItemClick?.(val);
  }

  return (
    <List
      options={sortByOptions}
      className="sort-by-modal"
      onClick={onClick}
      labelExtractor={(option): string => option.label}
      valueExtractor={(option): string => option.value}
      isSelected={(option): boolean => option.value === value}
      ariaLabel="Sort by options"
      dataTestId="sort-by-options-list"
    />
  );
}

export interface SortFilterOption {
  value: string | undefined;
  label: string;
}

export function useSortFilterOptions(): SortFilterOption[] {
  const { t } = useTranslation();
  return [
    { value: undefined, label: t('srp.sortBy.bestMatch') },
    { value: 'price:asc', label: t('srp.sortBy.priceCheap') },
    { value: 'price:desc', label: t('srp.sortBy.priceExpensive') },
    { value: 'distance:asc', label: t('srp.sortBy.distance') },
    { value: 'year:desc', label: t('srp.sortBy.yearNewest') },
    { value: 'year:asc', label: t('srp.sortBy.yearOldest') },
    { value: 'mileage:asc', label: t('srp.sortBy.mileageLowest') },
    { value: 'mileage:desc', label: t('srp.sortBy.mileageHighest') },
    { value: 'created_at:desc', label: t('srp.sortBy.timeOnMarketShortest') },
    { value: 'created_at:asc', label: t('srp.sortBy.timeOnMarketLongest') },
  ];
}
